// eslint-disable-next-line @typescript-eslint/no-empty-function
import React from "react";
import {getDefaultStatefulContext, State} from "@lib/hooks/types";

export const SearchDialogOpenContext = React.createContext<State<boolean>>(getDefaultStatefulContext<boolean>(false));